/** Sum of scope-of-work proposal breakdown line amounts (materials + labor + rentals). */
export function sumProposalBreakdownAmounts(materials, labor, rentals) {
  const m = Number(materials) || 0;
  const l = Number(labor) || 0;
  const r = Number(rentals) || 0;
  return Math.round((m + l + r) * 100) / 100;
}

/** True when any breakdown amount is greater than zero. */
export function hasProposalBreakdownAmounts(materials, labor, rentals) {
  return sumProposalBreakdownAmounts(materials, labor, rentals) > 0;
}

/**
 * Proposal total for save/display: use breakdown sum when breakdown is present,
 * otherwise keep the user-entered proposal total.
 */
export function resolveProposalTotalAmount({
  proposal_total_amount,
  proposal_materials_amount,
  proposal_labor_amount,
  proposal_rentals_amount,
}) {
  if (
    hasProposalBreakdownAmounts(
      proposal_materials_amount,
      proposal_labor_amount,
      proposal_rentals_amount
    )
  ) {
    return sumProposalBreakdownAmounts(
      proposal_materials_amount,
      proposal_labor_amount,
      proposal_rentals_amount
    );
  }
  return Math.round((Number(proposal_total_amount) || 0) * 100) / 100;
}
